export default "__VITE_ASSET__iEP1m2_e__"